module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-sawa-ad0a491a4a11c01a7714651b8225fb67.webp";